import React, { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { HiXMark } from 'react-icons/hi2';

/* Extracts a plain address from crypto URI schemes:
   bitcoin:ADDRESS?amount=...
   ethereum:ADDRESS
   tron:ADDRESS
   Or returns the raw string if it's already a plain address. */
function parseQRAddress(raw) {
  const match = raw.match(/^(?:bitcoin|ethereum|tron):([^?&\s]+)/i);
  return match ? match[1] : raw.trim();
}

export default function QRScanner({ open, onScan, onClose }) {
  const scannerRef = useRef(null);
  const divId = 'ikhua-qr-reader';

  useEffect(() => {
    if (!open) return;

    const scanner = new Html5Qrcode(divId);
    scannerRef.current = scanner;

    scanner.start(
      { facingMode: 'environment' },
      { fps: 10, qrbox: { width: 240, height: 240 } },
      (decoded) => {
        const address = parseQRAddress(decoded);
        onScan(address);
        scanner.stop().catch(() => {});
        scannerRef.current = null;
      },
      () => { /* per-frame errors are normal while focusing — ignore */ }
    ).catch((err) => {
      console.error('QR start failed:', err);
      onClose();
    });

    return () => {
      scannerRef.current?.stop().catch(() => {});
      scannerRef.current = null;
    };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!open) return null;

  const handleClose = () => {
    scannerRef.current?.stop().catch(() => {});
    scannerRef.current = null;
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: '#000', display: 'flex', flexDirection: 'column',
    }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', background: 'rgba(0,0,0,0.6)' }}>
        <span style={{ fontSize: '17px', fontWeight: 800, color: '#fff' }}>Scan Address</span>
        <button
          onClick={handleClose}
          style={{ background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: 12, width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#fff' }}
        >
          <HiXMark size={20} />
        </button>
      </div>

      {/* Camera view */}
      <div style={{ flex: 1, position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div id={divId} style={{ width: '100%', maxWidth: 430 }} />

        {/* Aim overlay */}
        <div style={{ position: 'absolute', pointerEvents: 'none', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
          <div style={{ width: 240, height: 240, border: '2px solid #7C5CF6', borderRadius: 16, boxShadow: '0 0 0 9999px rgba(0,0,0,0.45)' }} />
          <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)', background: 'rgba(0,0,0,0.5)', padding: '6px 14px', borderRadius: 20 }}>
            Point camera at QR code
          </span>
        </div>
      </div>
    </div>
  );
}
